import { render } from "./GeneratedReportsButton.vue?vue&type=template&id=31f98d84&scoped=true"
import script from "./GeneratedReportsButton.vue?vue&type=script&lang=js"
export * from "./GeneratedReportsButton.vue?vue&type=script&lang=js"

import "./GeneratedReportsButton.vue?vue&type=style&index=0&id=31f98d84&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31f98d84"]])

export default __exports__